import { useState } from 'react'
import { Edit, ListButton, TopToolbar, useRecordContext, useTranslate } from 'react-admin'
import { DocumentForm, documentRelations, ToggleShowButton } from '~/components'

const DocumentName = (props) => {
  const record = useRecordContext(props)

  const translate = useTranslate()
  return (
    <span>
      {record ? translate(`resources.documents.types.${record.type}`) : ''}:{' '}
      {record?.document_boat?.length > 0 ? record.document_boat[0].boat.model : ''}
    </span>
  )
}

const DocumentEditActions = ({ data, showPreview, setShowPreview }) => (
  <TopToolbar>
    <ToggleShowButton
      showState={showPreview}
      setShowState={setShowPreview}
      label='resources.documents.pdf_preview'
    />
    <ListButton label='ra.action.back' />
  </TopToolbar>
)

export const DocumentEdit = (props, record) => {
  const [showPreview, setShowPreview] = useState(false)

  return (
    <Edit
      title={<DocumentName />}
      actions={<DocumentEditActions showPreview={showPreview} setShowPreview={setShowPreview} />}
      {...props}
      transform={documentRelations}
      redirect='list'
    >
      <DocumentForm showPreview={showPreview} />
    </Edit>
  )
}

export default DocumentEdit
